// src/PasswordPrompt.tsx
import React from 'react';
import { Form, Input, Button } from 'antd';

interface PasswordPromptProps {
  onPasswordSubmit: (password: string) => void;
}

const PasswordPrompt: React.FC<PasswordPromptProps> = ({
  onPasswordSubmit,
}) => {
  const [form] = Form.useForm();
  const handleSubmit = (values: { password: string }) => {
    onPasswordSubmit(values.password);
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '300px',
          height: '150px',
          gap: '8px',
        }}
      >
        <p>This site is protected.</p>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please enter your password' }]}
          >
            <Input.Password
              placeholder="Basic password"
              id="password-input"
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default PasswordPrompt;
